import React from 'react';
import ReactNumberFormat from 'react-number-format';

export default function MyCurrency({ value, emptyString = "-" }) {
    if (!value) return emptyString;

    return <ReactNumberFormat value={value} displayType="text" thousandSeparator={true} prefix={'$ '} decimalScale={2} fixedDecimalScale />;
}